import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, OnInit, afterNextRender, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ChainHotelResponse } from '@core/models/DTOs/hotel.dto';
import { HotelRepository } from '@core/services/repositories/hotel.repository';
import { SwiperService } from '@shared/services/swiper-config.service';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import SwiperCore, { A11y, Autoplay, Grid, Navigation, Pagination, Scrollbar } from 'swiper';
import { SwiperModule } from 'swiper/angular';

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, Grid]);

@Component({
  selector: 'iho-chain-hotels',
  templateUrl: './chain-hotels.component.html',
  styleUrls: ['./chain-hotels.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NgOptimizedImage,
    SwiperModule,
    RouterLink
  ]
})
export class ChainHotelsComponent implements OnInit {
  configSwiper: any;
  configSwiperRev: any;
  resetSwiper = signal(true)
  cdnUrl = cdnUrl
  chainHotels: ChainHotelResponse[] = [{
    PictureName: '',
    PictureUrl: '',
    Url: ''
  }];
  constructor(
    public ChainService: HotelRepository,
    private swiperService: SwiperService
  ) {
    afterNextRender(() => {
      this.resetSwiper.set(false)
      setTimeout(() => this.resetSwiper.set(true), 0)
    })
  }

  ngOnInit(): void {
    this.chainHotels = [
        {
            "Url": "/parsgroup-residency/",
            "PictureUrl": "https://cdn.iranhotelonline.com/Application_Image/HomeBanners/7-chain hotel copy_پارس.svg",
            "PictureName": "گروه هتل های پارس"
        },
        {
            "Url": "/espinasgroup-residency/",
            "PictureUrl": "https://cdn.iranhotelonline.com/Application_Image/HomeBanners/9-chain hotel copy_اسپیناس.svg",
            "PictureName": "گروه هتل های اسپیناس"
        },
        {
            "Url": "/jahangardigroup-residency/",
            "PictureUrl": "https://cdn.iranhotelonline.com/Application_Image/HomeBanners/10-chain hotel copy_جهانگردی.svg",
            "PictureName": "گروه هتل های جهانگردی"
        },
        {
            "Url": "/sorinetgroup-residency/",
            "PictureUrl": "https://cdn.iranhotelonline.com/Application_Image/HomeBanners/11-chain hotel copy_سورینت.svg",
            "PictureName": "گروه هتل های سورینت"
        },
        {
            "Url": "/kowsargroup-residency/",
            "PictureUrl": "https://cdn.iranhotelonline.com/Application_Image/HomeBanners/12-chain hotel copy_کوثر.svg",
            "PictureName": "گروه هتل های کوثر"
            // "PictureUrl": "https://cdn.iranhotelonline.com/Application_Image/HomeBanners/13-chain hotel copy_لاله.svg",
            // "PictureName": "گروه هتل های لاله"
        },
        {
            "Url": "/mehrgroup-residency/",
            "PictureUrl": "https://cdn.iranhotelonline.com/Application_Image/HomeBanners/14-chain hotel copy_مهر.svg",
            "PictureName": "گروه هتل های مهر"
        },
        {
            "Url": "/homagroup-residency/",
            "PictureUrl": "https://cdn.iranhotelonline.com/Application_Image/HomeBanners/15-chain hotel copy_هما.svg",
            "PictureName": "گروه هتل های هما"
        },
        {
            "Url": "/parsiangroup-residency/",
            "PictureUrl": "https://cdn.iranhotelonline.com/Application_Image/HomeBanners/16-chain hotel copy_پارسیان.svg",
            "PictureName": "گروه هتل های پارسیان"
        },
        {
            "Url": "/heliagroup-residency/",
            "PictureUrl": "https://cdn.iranhotelonline.com/Application_Image/HomeBanners/81-chain hotel copy_هلیا.svg",
            "PictureName": "گروه هتل های کایا"
        }
    ]

    const config = {
      slide: "auto",
      pagination: {
        enabled: false,
        clickable: false,
      },
      autoplay: {
        delay: 5000,
      },
    };

    const configRev = {
      slide: "auto",
      pagination: {
        enabled: false,
        clickable: false,
      },
      autoplay: {
        delay: 3000,
        reverseDirection: true,
      },
    };

    this.configSwiper = this.swiperService.SwiperConfig(config);
    this.configSwiperRev = this.swiperService.SwiperConfig(configRev);

  }

}
